<template>

  <div class="">
    <b-overlay :show="show" spinner-variant="primary" spinner-large rounded="sm" style="height:100vh" variant="dark"
      id="loader">

      <b-container fluid style="padding-top: 100px;text-align:left">
        <b-row>
          <b-col cols="12 headerF">
            <HeaderFixed />
          </b-col>
          <b-col cols="12 headerM">
            <HeaderMobile />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-breadcrumb style=" background-color: #e9ecef78;">
              <b-breadcrumb-item href="#home">
                <router-link to="/">
                  <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                  Home
                </router-link>
              </b-breadcrumb-item>

              <b-breadcrumb-item href="#" active>Apply New Connection</b-breadcrumb-item>
            </b-breadcrumb>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">Apply for New Connection</span>
          </b-col>
        </b-row>
        <hr />
        <div class="paddingLeft30px">
          <form>
            <br>
            <b-row>
              <b-col cols=12 sm="12" md="3" lg="3" style="padding-top: 7px;">
                <span style="font-weight:600">District <span class="text-danger">*</span></span>
              </b-col>
              <b-col cols=12 sm="12" md="4" lg="4">
                <select name="" id="selectDistrict" required style="margin:10px 10px;width:250px"
                  @change="showSubdiv('selectDistrict')">
                  <option selected disabled value="000">--Select--</option>
                </select>
              </b-col>
              <b-col cols=12 sm="12" md="4" lg="4" style="padding-top: 7px;">
                <span style="font-weight:600">
                  <a href="EstimateServiceCost">
                    Service connection estimate calculator
                  </a>
                  <img src='https://www.apdcl.org/website/assets/new.gif' />
                </span>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols=12 sm="12" md="3" lg="3" style="padding-top: 7px;">
                <span style="font-weight:600">Subdivision <span class="text-danger">*</span></span>
              </b-col>
              <b-col cols=12 sm="12" md="4" lg="4">
                <select name="" id="selectSubDiv" required style="margin:10px 10px;width:250px">
                  <option selected disabled value="000">--Select--</option>
                </select>
              </b-col>
              <!--<b-col cols=12 sm="12" md="4" lg="4">
            <a  href="https://www.apdcl.org/website/docs/documents/form/New Service Connection Charges.pdf" target="_blank">
           <span style="font-size: 0.8rem;">(Service connection charges with load above 30 kW and upto 150kW for FY 2024-25, as approved by AERC)</span><img src='https://www.apdcl.org/website/assets/new.gif' />
            </a>
          </b-col>-->
            </b-row>
            <b-row>
              <b-col cols="12" sm="12" md="2" lg="2" offset-lg=3 offset-md=3>
                <b-button @click="redirectUrl()" block pill variant="primary" size="md" class="go" style="width:100%">
                  <b-icon icon="arrow-right-short" animation="" scale="1.8"> </b-icon>
                </b-button>
              </b-col>
            </b-row>
          </form>
          </br>
        </div>

        <div class="paddingLeftRem">

          <h4>Required documents for New Electricity Connection</h4>
          <ol style="padding-left:2em;padding-top:1em;">
            <li>
              Latest Passport Size Photo of the Applicant (in jpeg or png format)
            </li>
            <li>
              Proof of Identity (Voter identity card / Passport / Driving license / Ration card/ BPL card/ / PAN card /
              Aadhaar Card / Photo identity Certificate from local competent authority)
            </li>
            <li>
              Residential Address Proof (Driving License/ Bank Passbook/ Ration Card / Aadhaar Card / Telephone Bill /
              BPL Card / Existing Electricity Bill/ Passport/ Certificate from local competent authority)
            </li>
            <li>
              Proof of the legal occupation of the premises(Holding No., Lease Agreement, Rent Agreement, Sale Deed)
            </li>
            <li>
              Affidavit from land owner indicating no objection to give connection to the applicant and indemnity bond
              (Optional) from the owner, if the applicant is not the owner of the land.
            </li>
            <li>
              Test report from authorized electrical contractor / supervisor.
              <a href="https://www.apdcl.org/website/docs/documents/form/Test_Report_Format_for_3rd_party_certification.pdf"
                target="_blank">
                <img height="30px" width="30px" src="https://www.apdcl.org/website/assets/pdf-icon-3.png">Download Test
                Report Format
              </a>
            </li>
            <li>
              Standard Agreement Form.
              <a href="https://www.apdcl.org/website/docs/documents/form/Agreement_form_for_LT%20connection.pdf"
                target="_blank">
                <img height="30px" width="30px" src="https://www.apdcl.org/website/assets/pdf-icon-3.png">
                Download Agreement Format
              </a>
            </li>
            <li>
              Additional documents will be required for online HT connection apllication.
              <a href="https://apdclrms.com/cbs/cfs/V2/sampleFiles/HT-Document-requirement.pdf" target="_blank">
                <img height="30px" width="30px" src="https://www.apdcl.org/website/assets/pdf-icon-3.png">
                Download Document List
              </a>
            </li>
          </ol>

          <h4>Required documents for Temporary Electricity Connection</h4>
          <ol style="padding-left:2em;padding-top:1em;">
            <li>
              Photo Identity Proof of the applicant (Aadhar, PAN, Voter ID, etc.)
            </li>
            <li>
              Proof of Ownership of the premises where the temporary connection is applied
              <ul>
                <li>
                  a. If the applicant is not the owner, a No Objection Certificate (NOC) from the owner is required
                </li>
                <li>
                  b. If the premises belong to a local authority (such as a playground, field, etc.), an NOC from the
                  respective authority must be submitted
                </li>
              </ul>
            </li>
            <li>
              In case of a Firm or Company : Proof of Ownership or NOC from the Owner of the
              premises must be provided as authorization document
            </li>
            <li>
              If the temporary supply is required at a location where 100 or more persons are likely to assemble or
              in places specified under Section 54 (Control of Transmission and Use of Electricity) of the Indian
              Electricity Act, 2003,
              the applicant must notify the relevant authorities before the commencement of electricity transmission and
              usage
            </li>
            <li>
              A Test Report from an Authorized Electrical Contractor in the prescribed format
              <a href="https://www.apdcl.org/website/docs/documents/form/Test_report_format.pdf" target="_blank">
                <img height="30px" width="30px" src="https://www.apdcl.org/website/assets/pdf-icon-3.png">Download Test
                Report Format
              </a>
            </li>
            <li>
              A Declaration stating that no outstanding electricity dues exist against
              the said premises for any previous connection
              <a href="https://www.apdcl.org/website/docs/documents/form/declaration_format.pdf" target="_blank">
                <img height="30px" width="30px" src="https://www.apdcl.org/website/assets/pdf-icon-3.png">
                Download Declaration
              </a>
            </li>
          </ol>

          Note: Copies of all the documents uploaded shall be self-attested by the applicant and the original copy may
          be required to be produced at the time of inspection, if required by the licensee.
        </div>
      </b-container>

    </b-overlay>

    <b-modal id="model" centered scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="modalMsg"> </span>
      <br><br>
      <b-button style="width:8rem" variant="outline-info" @click="closeModal()">OK</b-button>
    </b-modal>
  </div>

</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
var thColor = '#0288d1';

export default {
  name: '',
  components: {

    'HeaderFixed': HeaderFixed,
    'HeaderMobile': HeaderMobile
    //MarqueeText

  },
  data() {
    return {
      consumerNo: '',
      sdCode: '',
      show: false,
    }
  },

  methods: {
    closeModal() {
      this.$bvModal.hide('model')
    },

    showSubdiv(x) {
      console.log("inside show");
      var distCode = document.getElementById(x).value;
      console.log(distCode);
      axios.get("https://www.apdclrms.com/cbs/RestAPI/getSubdiv?districtName=" + distCode)
        .then((response) => {

          console.log(response.data);
          document.getElementById("selectSubDiv").innerHTML = "";
          var select = document.getElementById("selectSubDiv");
          var option = document.createElement("option");
          option = document.createElement("option");
          option.text = "--Select--";
          option.value = 0;
          select.appendChild(option);

          response.data.forEach(element => {
            //console.log(item);
            var res = element.split("-")
            option = document.createElement("option");
            option.text = element;
            option.value = res[0];
            select.appendChild(option);
          })

        })
        .catch((e) => {
          parent.show = false;
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML = "Sorry, Consumer / Bill Not Found";
          console.log("Caught :::::::::::::::", e.message);

        })
    },
    redirectUrl() {

      var sV = document.getElementById("selectSubDiv").value;
      var dist = document.getElementById("selectDistrict").value;
      //var selValue = e.options[e.selectedIndex].value ;
      //alert(sV);

      if (sV == '000') {
        alert("Select a Subdivision");
        return
      }
      else {
        var url = this.$urlArms + '/onlinecrm/newconnectionFinal?subdiv=' + sV + '&district=' + dist + '&applType=NSC';
        window.open(url, '_blank');

      }
    }
  },

  mounted() {
    window.scrollTo(0, 0);
    axios.get('https://www.apdclrms.com/cbs/RestAPI/getAllDistricts')
      .then((response) => {

        console.log(response.data);
        //document.getElementById("selectDistrict").empty();
        var select = document.getElementById("selectDistrict");

        response.data.forEach(function (element, index) {
          //console.log(item);
          var option = document.createElement("option");
          option.text = element;
          option.value = element;
          select.appendChild(option);
        })

      })
      .catch((e) => {
        parent.show = false;
        parent.$bvModal.show('model');
        document.getElementById("modalMsg").innerHTML = "Sorry, Try Again";
        console.log("Caught :::::::::::::::", e.message);

      })

  }
}
//background-image: url('../assets/bg.jpg');background-color: #82828226;

</script>

<style scoped="true">
td {
  padding: 0.3rem;
}

.label {
  font-weight: 600;
}

.data {
  font-weight: 600;
  color: #ff5722;
  font-size: 1.5rem;
}

.hideDetails {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
  padding: 1rem;
}

.showDetails {
  visibility: visible;
  opacity: 1;
}

hr {
  margin-top: 5px;
  margin-bottom: 5px;
}

.go:focus {
  box-shadow: none;
}

.headerF {
  display: block;
}

.headerM {
  display: none;
}

.paddingLeft30px {
  padding-left: 30px;
}

.paddingLeftRem {
  padding-left: 1.5rem;
}

@media (max-width: 768px) {
  .headerF {
    display: none;
  }

  .headerM {
    display: block;
  }

  .paddingLeft30px {
    padding-left: 0px;
  }

  .paddingLeftRem {
    padding-left: 0rem;
  }
}
</style>
